import React, { Component } from "react";
import { Grid, Row, Col, Pagination, Button } from "react-bootstrap";
import Highlight from './Highlight.js';
import SearchExamples from './SearchExamples.js';
import Feature from './content/Feature.js';
import "./SearchResults.css";
import mixpanel from "mixpanel-browser";
import { LinkContainer } from "react-router-bootstrap";
import DownloadLists from './DownloadLists.js';



class SearchResults extends Component {
    constructor(props) {
        super(props);        
        this.state = {
            activePage: 1
        };
        this.handleSelect = this.handleSelect.bind(this);
        this.renderNoResultsFragment = this.renderNoResultsFragment.bind(this);
        this.handleSearchExample = this.handleSearchExample.bind(this);
        this.handleGetBusinessDetails = this.handleGetBusinessDetails.bind(this);

        this.mixpanel = mixpanel;
    }

    handleSelect(eventKey) {
        this.setState({
            activePage: eventKey
        });
        this.props.handlePageRequest(eventKey);
    }

    handleSearchExample() {
    	this.props.handleSubmitWithOptionsUpdate(0, 'bootstrap.min.js', 'Top 500k', 'JS & HTML');
    }

    handleGetBusinessDetails() {
    	this.mixpanel.track("Get Business details", {});
    	let newtab = window.open( '', '_blank' );
    	newtab.location = "https://www.clientcrowd.com?ref=webfinerysearchresults";
    }

    //usage: <div>{this.badges(item.highlight)}</div>
    /*
    badges(highlight) {
    	console.log(highlight);  	
    	return Object.keys(highlight).map(name => (
    		<Badge key={name + highlight[name]}>{name}</Badge>
    	))
    }*/

    capitalizeFirstLetter(string) {
    	return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
	}

	getDomain(item) {
    	//return item._source.title ? item._source.title : item._source.domain;
    	var url = item._source.url;
    	var matches = url.match(/^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:\/\n\?\=]+)/im);
  		return this.capitalizeFirstLetter(matches[1]);
    }

    getTitle(item) {
    	return this.limit(item._source.title, 200);
    }

    limit(string, max) {
    	if (string) {
    		if (string.length > 100) {
    			return string.substring(0, max) + "...";
    		}
    	}
    	return string;
    }

    getDataSetLabel() {
    	return <strong>{this.props.dataSet}</strong>
    }

    renderNoResultsFragment() {
    	return (
    		<div style={{paddingBottom: "5%"}} className="text-center">
	    		<Grid>
	    			<Row>
	    				<Col md={12}>
				    		<h2>No match found in {this.getDataSetLabel()} websites.</h2>
				    		<Button bsSize="small" onClick={this.props.handleUpgradeRequest} className="strong">
                            	Limited Results. Upgrade?
                            </Button>
				    		<p>

				    			
				    		</p>
	    				</Col>
	    			</Row>
	    		</Grid>
	    		<Feature innerFeatureList={true} shade={true} borderless={true} h3="examples">
	    			<SearchExamples handleSubmitWithOptionsUpdate={this.props.handleSubmitWithOptionsUpdate}></SearchExamples>
	    		</Feature>
	    		<DownloadLists shade={true} borderless={true}/>
    		</div>
    	);
    }

    renderSalesLead() {

    	return (
            <div className="hit" style={{textAlign: "left", opacity: 0.6}}>    		
				<Button bsStyle="link" onClick={this.handleGetBusinessDetails}>Get Company and Contact Details for These Websites <i className="fa fa-external-link" aria-hidden="true"></i></Button>
			</div>
    	);
    }

    renderAlternativeCall() {
    	return (
			<Grid fluid={true}>
                <Row>
                    <Col smOffset={1} sm={5} xs={6}>                        	
                    	{ this.props.searchResults.hits.total !== 0 && this.renderSalesLead() }                        	
                    </Col>
                    <Col sm={5} xs={6} style={{textAlign: "right"}}>
                    	<LinkContainer to="/lists">
                    		<Button bsStyle="link">Browse Lists</Button>
                    	</LinkContainer>
                    	<Button disabled={this.props.loading || this.props.searchResults.hits.total === 0} bsStyle="danger" onClick={this.props.handleExportClick}>Export &amp; Download CSV</Button>                        	
                    </Col>
                </Row>
            </Grid>    		
    	)
    }

    render() {
        let duration = "";
        if (this.props.searchResults.took) {
            duration = (
                <span>({this.props.searchResults.took / 1000}s)</span>
            );
        }        

        let classNameLoading = this.props.loading
            ? "searchResultItemsLoading"
            : "";

        //limiting according to the ES limit from + pageSize <= 10k
        let pageCount = Math.ceil(Math.min(9999 / this.props.pageSize, this.props.searchResults.hits.total / this.props.pageSize));        

        let pagination = this.props.searchResults.hits.total === 0 ? null :
			(
            	<div className="paginationContainer">

                    <Pagination
                        prev
                        next
                        //first
                        //last
                        //ellipsis
                        //boundaryLinks
                        items={pageCount}
                        maxButtons={3}
                        activePage={this.state.activePage}
                        onSelect={this.handleSelect}
                        className="visible-xs-inline"
                    />

                    <Pagination
                        prev
                        next
                        first
                        last
                        //ellipsis
                        //boundaryLinks
                        items={pageCount}
                        maxButtons={5}
                        activePage={this.state.activePage}
                        onSelect={this.handleSelect}
                        className="hidden-xs-block visible-sm-inline"
                    />

                    <Pagination
                        prev
                        next
                        first
                        last
                        //ellipsis
                        //boundaryLinks
                        items={pageCount}
                        maxButtons={10}
                        activePage={this.state.activePage}
                        onSelect={this.handleSelect}
                        className="hidden-xs-inline hidden-sm-inline visible-md-inline visible-lg-inline"
                    />

                </div>
            )

        return (
            <div className="SearchResults">
                <Grid fluid={true}>
                    <Row>
                        <Col smOffset={1} sm={5} xs={6}>
                            <div className="SearchResultsTotal">
                                {this.props.searchResults.hits.total}
                                {" "}matches{" "}in{" "}{this.getDataSetLabel()}{" "}
                                <span className="hidden-xs">{duration}</span>
                            </div>
                            <Button bsSize="small" onClick={this.props.handleUpgradeRequest} className="strong">
                            	Limited Results. Upgrade?
                            </Button>
                        </Col>
                        <Col sm={5} xs={6} style={{textAlign: "right"}}>
                        	<Button disabled={this.props.loading || this.props.searchResults.hits.total === 0} bsStyle="danger" onClick={this.props.handleExportClick}>Export &amp; Download CSV</Button>
                        </Col>
                    </Row>
                </Grid>

                <Grid
                    className={"SearchResultItems " + classNameLoading}
                    fluid={true}                    
                >
                    {this.props.searchResults.hits.hits.map((item, index) => (

                        <Row key={index}>

                            <Col smOffset={1} sm={10} xs={12}>
                                <div className="hit">
                                    <h3>{this.getDomain(item)} <small>{this.getTitle(item)}</small>
                                    </h3>

                                    <Highlight data={item.highlight} userQuery={this.props.userQuery}/>
                                    <div className="originalReference"><a href={item._source.url} target="_blank">Ref <i className="fa fa-external-link" aria-hidden="true"></i></a></div>
                                </div>
                            </Col>
                        </Row>
                    ))}
                    
                </Grid>

                { this.props.searchResults.hits.total !== 0 && this.renderAlternativeCall() } 

                <Grid fluid={true}>
                    <Row>
                    	<Col smOffset={1} sm={5} xs={6}>&nbsp;</Col>
                    	<Col smOffset={1} sm={10} xs={12}>
							{pagination}
		                </Col>
                    </Row>                    
                </Grid> 

                { this.props.searchResults.hits.total === 0 && this.renderNoResultsFragment() } 

            </div>
        );
    }
}

export default SearchResults;



// WEBPACK FOOTER //
// ./src/SearchResults.js